"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedHttpSettings = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const ConfigSection_1 = require("../ConfigSection");
const AdvancedHttpSettings = ({ config, onChange, className, }) => {
    const onCookiesChange = (cookies) => {
        onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { keepCookies: cookies }) }));
    };
    const onTimeoutChange = (event) => {
        onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { timeout: parseInt(event.currentTarget.value, 10) }) }));
    };
    const styles = {
        container: (0, css_1.css)({
            maxWidth: 578,
        }),
    };
    return (react_1.default.createElement(ConfigSection_1.ConfigSubSection, { title: "Advanced HTTP settings", className: (0, css_1.cx)(styles.container, className) },
        react_1.default.createElement(ui_1.InlineField, { htmlFor: "advanced-http-cookies", label: "Allowed cookies", labelWidth: 24, tooltip: "Grafana proxy deletes forwarded cookies by default. Specify cookies by name that should be forwarded to the data source.", disabled: config.readOnly, grow: true },
            react_1.default.createElement(ui_1.TagsInput, { id: "advanced-http-cookies", placeholder: "New cookie (hit enter to add)", tags: config.jsonData.keepCookies, onChange: onCookiesChange })),
        react_1.default.createElement(ui_1.InlineField, { htmlFor: "advanced-http-timeout", label: "Timeout", labelWidth: 24, tooltip: "HTTP request timeout in seconds", disabled: config.readOnly, grow: true },
            react_1.default.createElement(ui_1.Input, { id: "advanced-http-timeout", type: "number", min: 0, placeholder: "Timeout in seconds", "aria-label": "Timeout in seconds", value: config.jsonData.timeout, onChange: onTimeoutChange }))));
};
exports.AdvancedHttpSettings = AdvancedHttpSettings;
//# sourceMappingURL=AdvancedHttpSettings.js.map